import { useSelector } from "react-redux";
import { fullSidebarSelector } from "../redux/slices/appState/appStateSelector";

export const useGridContainer = (isModalView = false) => {
  const { isOpen: isSidebarOpen } = useSelector(fullSidebarSelector);
  const isSidebarOpenOrIsModalView = isSidebarOpen || isModalView;

  // for search scree where we need to show 3 columns full view and 2 columns with sidebar
  const gridSizeLarge = isSidebarOpenOrIsModalView
    ? { lg: 6, md: 6, xs: 12, sm: 6 }
    : { lg: 4, md: 6, xs: 12, sm: 6 };

  // for create scree where we need to show 4 columns full view and 3 columns with sidebar
  const gridSizeMedium = isSidebarOpenOrIsModalView
    ? { lg: 4, md: 6, xs: 12, sm: 6 }
    : { lg: 3, md: 4, xs: 12, sm: 6 };

  return {
    gridSizeLarge,
    gridSizeLargeClass: isSidebarOpenOrIsModalView
      ? "grid-size-large"
      : "grid-size-large-full",
    gridSizeMedium,
    gridSizeMediumClass: isSidebarOpenOrIsModalView
      ? "grid-size-medium"
      : "grid-size-medium-full",
  };
};
